export default __webpack_public_path__ + "locales/fr/Ldap.json?hash=6305a04a57d25c6b09c1c10f5282155c";